import React from 'react';
const faqs = [{
  q: '¿Este producto es físico o digital?',
  a: 'Es un producto 100% digital en formato PDF.'
}, {
  q: '¿Cómo y cuándo lo recibo?',
  a: 'Lo recibís inmediatamente luego del pago.'
}, {
  q: '¿Necesito conocimientos previos?',
  a: 'No. Todo está explicado paso a paso.'
}, {
  q: '¿Puedo verlo desde mi celular?',
  a: 'Sí, podés usarlo desde celular, tablet o PC.'
}, {
  q: '¿Los ingredientes son difíciles de conseguir?',
  a: 'No. La mayoría son ingredientes fáciles de encontrar.'
}, {
  q: '¿Los remedios reemplazan atención médica?',
  a: 'No. La guía está pensada como complemento educativo y de bienestar natural.'
}];
export function FAQ() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-center mb-12 uppercase" data-id="element-42">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-44">
              <h3 className="text-lg font-bold text-black mb-2" data-id="element-45">{faq.q}</h3>
              <p className="text-gray-700 font-medium flex gap-2" data-id="element-46">
                <span className="text-brand-green font-bold" data-id="element-47">👉</span>
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}